export default __webpack_public_path__ + "static/media/41_photo.678414cd.jpg";